import React from "react";
import { useTranslation } from "react-i18next";

import DoNotMountComponent from "../../DoNotMountComponent/DoNotMountComponent";
import NextGenerationEU from "../../NextGenerationEU/NextGenerationEU";
import SocialLinksList from "../../SocialsLinks/SocialLinksList";
import { useLayout } from "../LayoutContext";

export const Footer: React.FC = () => {
  const { legalLinks } = useLayout();

  if (!legalLinks || legalLinks.length < 1) return <DoNotMountComponent sms={"Footer sin legales"} log={legalLinks} />;
  const { t } = useTranslation("global");
  return (
    <div className="m-footer">
      <div className="c-footer">
        {/*<SocialLinksList />*/}
        {/*<NextGenerationEU itemsColor="light" />*/}
        <div className="footer__foot-line">
          {/*<div className="footer__copy">© 2024</div>*/}
          <div className="footer__legal">
            {legalLinks.map((legal, index) => {
              return (
                <a
                  className={"footer__link"}
                  key={index}
                  href={`${legal.slug}`}
                  title={`${legal.name}`}
                  aria-label={`${t("goto")} ${legal.name}`}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                >
                  {legal.name}
                </a>
              );
            })}
            <button className={"footer__button-settings"} type="button" data-cc="show-preferencesModal">
              {t("Configuración cookies")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
